module.exports = __webpack_public_path__ + "media/assets/img/screenshots/races-by-distances-d655929f6fef4b993534d6e37cebba13.png";